import React from 'react';
import classes from './Button.module.scss'
import sweepstakesLogo from './takis-logo-flames.png';
import walmartLogo from './material-symbols_quiz-outline-rounded.png';

const Button = props => {
    let propsStyle;
    if(props.style) {

        console.log(props.style);
        propsStyle = {
            backgroundColor : props.style.backgroundColor,
            color : props.style.color,
            fontSize: props.style.fontSize,
            marginTop: '10px',
        }
        propsStyle = {
            backgroundColor : props.style.backgroundColor,
            color : props.style.color,
            fontSize: props.style.fontSize,
            borderRadius: props.style.borderRadius,
            marginTop: props.style.marginTop,
            height: props.style.height
        }        

        propsStyle = props.style;

        if(props.useGradient) {
            console.log('use gradient');
            // propsStyle.background= "linear-gradient(180deg, #7A3BA5 0%, #4D1176 100%)";
        }
        // propsStyle = props.style;
    }
    return (
        <button style={propsStyle ? propsStyle : {backgroundColor: props?.backgroundColor ?? '#171C8F', marginTop : '10px'}} onClick={props.onClick} className={props.outlined ? classes.OutlinedButton : classes.MaterialButton}>
            {props.btnText === 'Enter Sweepstakes' && <img style={{paddingRight: "10px", height: "22px", width: "40px"}} src={sweepstakesLogo} alt="Sweepstakes Logo" />}
            {props.btnText === 'Exclusive Walmart Offer' && <img style={{paddingRight: "10px", height: "21px", width: "24px"}} src={walmartLogo} alt="Walmart Logo" />}
            {props.btnText}
        </button>
    );
}

export default Button;
